<template>
  <b-modal ref="coupon-card-modal" @ok="couponCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.coupons.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.coupons.tableColumns.fuelTypeCode"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="fuelTypeCode"
          :state="isFuelTypeCodeValid"
          :options="fuelTypeCodeOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.coupons.tableColumns.fuelVolume"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="-9999999999"
          max="9999999999"
          v-model="fuelVolume"
          :state="isFuelVolumeValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        locale="ua"
        :label="$store.state.localization.data.mainPage.coupons.tableColumns.beginTime"
        label-for="input-horizontal"
      >
        <b-form-datepicker
          v-model="beginTime"
          :state="isBeginTimeValid"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        locale="ua"
        :label="$store.state.localization.data.mainPage.coupons.tableColumns.endTime"
        label-for="input-horizontal"
      >
        <b-form-datepicker
          v-model="endTime"
          :state="isEndTimeValid"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.coupons.tableColumns.cardId"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="cardId"
          :state="isCardIdValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.coupons.tableColumns.status"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="status"
          :state="isStatusValid"
          :options="statusOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import { couponService, utilsService } from "../../../services";

export default {
  name: "CreateCouponPage",
  components: {},
  data() {
    return {
      fuelTypeCode: null,
      fuelVolume: null,
      beginTime: null,
      endTime: null,
      cardId: null,
      status: null,
      isFuelTypeCodeValid: null,
      isBeginTimeValid: null,
      isEndTimeValid: null,
      isFuelVolumeValid: null,
      isCardIdValid: null,
      isStatusValid: null,
    };
  },
  computed: {
    statusOptions() {
      const statusOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.coupons.statusOptions
          .length;
        i++
      ) {
        statusOptions.push({
          value:
            this.$store.state.localization.data.mainPage.coupons.statusOptions[
              i
            ].key,
          text: this.$store.state.localization.data.mainPage.coupons
            .statusOptions[i].value,
        });
      }
      return statusOptions;
    },
    fuelTypeCodeOptions() {
      const fuelTypeCodeOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.common.fuelTypeCodeOptions.length;
        i++
      ) {
        fuelTypeCodeOptions.push({
          value:
            this.$store.state.localization.data.common.fuelTypeCodeOptions[i]
              .key,
          text: this.$store.state.localization.data.common.fuelTypeCodeOptions[
            i
          ].value,
        });
      }

      return fuelTypeCodeOptions;
    },
    calendarLocale() {
      return utilsService.getCalendarLocale(this.$store.state.localization.locale);
    }
  },
  methods: {
    open() {
      this.fuelTypeCode = null;
      this.fuelVolume = null;
      this.beginTime = null;
      this.endTime = null;
      this.cardId = null;
      this.status = null;

      this.$refs["coupon-card-modal"].show();
    },
    async couponCardModalOk(event) {
      if (!this.fuelTypeCode) {
        this.isFuelTypeCodeValid = false;
        event.preventDefault();
        return;
      } else {
        this.isFuelTypeCodeValid = null;
      }

      if (!this.fuelVolume) {
        this.isFuelVolumeValid = false;
        event.preventDefault();
        return;
      } else {
        this.isFuelVolumeValid = null;
      }

      if (!this.beginTime) {
        this.isBeginTimeValid = false;
        event.preventDefault();
        return;
      } else {
        this.isBeginTimeValid = null;
      }

      if (!this.endTime) {
        this.isEndTimeValid = false;
        event.preventDefault();
        return;
      } else {
        this.isEndTimeValid = null;
      }

      if (this.beginTime > this.endTime) {
        this.isBeginTimeValid = false;
        event.preventDefault();
        return;
      } else {
        this.isBeginTimeValid = null;
      }

      if (!this.cardId) {
        this.isCardIdValid = false;
        event.preventDefault();
        return;
      } else {
        this.isCardIdValid = null;
      }

      if (!this.status) {
        this.isStatusValid = false;
        event.preventDefault();
        return;
      } else {
        this.isStatusValid = null;
      }

      const fuelVolume = parseFloat(this.fuelVolume);

      if (isNaN(fuelVolume) || fuelVolume <= 0) {
        this.isFuelVolumeValid = false;
        event.preventDefault();
        return;
      } else {
        this.isFuelVolumeValid = null;
      }

      const couponCard = {
        fuelTypeCode: this.fuelTypeCode,
        fuelVolume: fuelVolume,
        beginTime: parseInt(this.beginTime.getTime() / 1000),
        endTime: parseInt(this.endTime.getTime() / 1000),
        cardId: this.cardId,
        status: parseInt(this.status),
      };

      const createCouponResponse = await couponService.createCoupon(couponCard);

      if (
        createCouponResponse.isSuccess &&
        createCouponResponse.data &&
        createCouponResponse.data.countInsertedRows != 0
      ) {
        this.$emit("couponCreatedSuccessEvent", couponCard);
      } else {
        this.$emit("couponCreatedFailEvent");
      }
    },
  },
};
</script>
